export default typeof window !== `undefined` ? window : undefined;
